import type { fr } from './fr';

export const en: typeof fr = {
  slogan: 'Evolve. Dominate. Restart.',
  playGuest: 'Play as guest',
  namePlaceholder: 'Your tank name',
  connecting: 'Connecting to server…',
  disconnected: 'Connection lost. Retrying…',
  serverVersion: 'Outdated game version: please reload.',
  modeFfa: 'Free arena (FFA)',
  modeFfaDesc: 'Everyone for themselves, labelled bots fill the arena.',
  classTree: 'Class tree',
  settings: 'Settings',
  help: 'Help',
  close: 'Close',
  back: 'Back',
  language: 'Language',
  level: 'Level {n}',
  score: 'Score',
  rank: 'Rank {r}/{n}',
  leaderboard: 'Leaderboard',
  paint_open: 'Customize',
  paint_title: 'Paint workshop',
  paint_intro: 'Paint every part of your tank. Colour is free; materials, patterns, decals and effects come from chests or can be bought. Nothing changes the hitbox or the shots.',
  paint_needAccount: 'Create an account to customize your tank: your look is saved on your account and seen by other players.',
  paint_previewKill: 'Preview elimination',
  paint_previewDeath: 'Preview death',
  paint_tryOn: 'Trying on: {list} — not owned, won’t be saved.',
  paint_save: 'Save',
  paint_saved: 'Look saved: it applies in game too.',
  paint_reset: 'Reset everything',
  paint_unsaved: 'Unsaved changes.',
  paint_bought: '{name} unlocked.',
  paint_tab_paint: 'Paint',
  paint_tab_fx: 'Effects',
  paint_tab_chests: 'Chests',
  paint_tab_buy: 'Buy',
  paint_parts: 'Parts',
  paint_part_hull: 'Hull',
  paint_part_treads: 'Treads',
  paint_part_turret: 'Turret',
  paint_part_barrels: 'Barrels',
  paint_color: 'Colour',
  paint_customColor: 'Other colour',
  paint_material: 'Material',
  paint_pattern: 'Pattern',
  paint_patternColor: 'Pattern colour',
  paint_decal: 'Decal',
  paint_decalColor: 'Decal colour',
  paint_decalWhere: 'Decals go on the treads.',
  paint_none: 'None',
  paint_models: 'Presets',
  paint_modelsHint: 'Your old skins: their colours apply to the four parts, then you can tweak them.',
  paint_slot_mat: 'Materials',
  paint_slot_pat: 'Patterns',
  paint_slot_dec: 'Decals',
  paint_slot_aura: 'Aura',
  paint_slot_trail: 'Trail',
  paint_slot_shot: 'Shot effect',
  paint_slot_kill: 'Elimination effect',
  paint_slot_death: 'Death effect',
  paint_fxHint: 'The preview shows the aura and the trail; tap the tank to see the shot effect.',
  paint_wallet: '{c} coins · {g} gems',
  paint_coins: '{n} coins',
  paint_gems: '{n} gems',
  paint_chestOdds: 'Odds',
  paint_chestOpen: 'Open',
  paint_chestConfirm: 'Confirm: {n} coins',
  paint_dupRule: 'An item you already own is refunded in coins: {list}.',
  paint_earnedCoins: 'Coins earned by playing, usable for chests: {n}',
  paint_chestDup: 'Already owned: +{n} coins',
  paint_chestNew: 'New! Added to your collection.',
  paint_chestHistory: 'Recent chests',
  paint_owned: 'Owned',
  paint_buyConfirm: 'Confirm: {n} gems',
  paint_err_funds: 'Not enough coins or gems.',
  paint_err_earned: 'Chests open with coins earned by playing, not coins converted from gems.',
  paint_classic: 'Classic look',
  paint_classicDone: 'Classic look restored: your class styles and skins show again.',
  paint_err_verify: 'Verify your email address to open chests and buy.',
  paint_err_frozen: 'Purchases are blocked on this account.',
  paint_err: 'Something went wrong, please try again.',
  rarity_commun: 'Common',
  rarity_rare: 'Rare',
  rarity_epique: 'Epic',
  rarity_legendaire: 'Legendary',
  rarity_mythique: 'Mythic',
  chest_bronze: 'Bronze chest',
  chest_argent: 'Silver chest',
  chest_or: 'Gold chest',
  cos_mat_mat: 'Matte',
  cos_mat_satin: 'Satin',
  cos_mat_brosse: 'Brushed metal',
  cos_mat_carbone: 'Carbon',
  cos_mat_chrome: 'Chrome',
  cos_mat_nacre: 'Pearl',
  cos_mat_or: 'Gold',
  cos_mat_neon: 'Neon',
  cos_mat_magma: 'Magma',
  cos_pat_rayures: 'Stripes',
  cos_pat_damier: 'Checkers',
  cos_pat_camo: 'Camouflage',
  cos_pat_hexa: 'Hexagons',
  cos_pat_ecailles: 'Scales',
  cos_pat_circuit: 'Circuit',
  cos_pat_tigre: 'Tiger',
  cos_pat_flammes: 'Flames',
  cos_dec_etoile: 'Star',
  cos_dec_chevrons: 'Chevrons',
  cos_dec_cible: 'Target',
  cos_dec_eclair: 'Lightning',
  cos_dec_flamme: 'Flame',
  cos_dec_griffe: 'Claws',
  cos_dec_ailes: 'Wings',
  cos_dec_couronne: 'Crown',
  cos_dec_crane: 'Skull',
  cos_dec_dragon: 'Dragon',
  cos_aura_etincelles: 'Sparks',
  cos_aura_flocons: 'Snowflakes',
  cos_aura_braises: 'Embers',
  cos_aura_lucioles: 'Fireflies',
  cos_aura_orage: 'Storm',
  cos_aura_runes: 'Rune ring',
  cos_trail_poussiere: 'Dust',
  cos_trail_lumiere: 'Light wake',
  cos_trail_bulles: 'Bubbles',
  cos_trail_flammes: 'Flames',
  cos_trail_etoiles: 'Stardust',
  cos_trail_arcenciel: 'Rainbow',
  cos_shot_etincelles: 'Spark burst',
  cos_shot_fumee: 'Powder smoke',
  cos_shot_plasma: 'Plasma ring',
  cos_shot_etoile: 'Star flash',
  cos_kill_confettis: 'Confetti',
  cos_kill_onde: 'Shockwave',
  cos_kill_foudre: 'Thunder',
  cos_kill_supernova: 'Supernova',
  cos_death_eclats: 'Armour shards',
  cos_death_fumee: 'Black smoke',
  cos_death_implosion: 'Implosion',
  cos_death_vaporisation: 'Vaporization',
  minimap: 'Map',
  evolveChip: 'Evolution ({n})',
  modChip: 'Upgrade to pick',
  worldTitle: 'Boss & map',
  panelHide: 'Hide: {name}',
  panelShow: 'Show: {name}',
  arenaPop: '{h} humans · {b} bots',
  bot: 'BOT',
  statPoints: '{n} point(s) to spend',
  stat_maxHealth: 'Max health',
  stat_regen: 'Regeneration',
  stat_bodyDamage: 'Body damage',
  stat_moveSpeed: 'Movement speed',
  stat_bulletDamage: 'Projectile damage',
  stat_penetration: 'Penetration',
  stat_bulletSpeed: 'Projectile speed',
  stat_reload: 'Fire rate',
  evolveTitle: 'Evolution available',
  evolveLater: 'Later',
  evolveNext: 'Next evolution at level {n}',
  evolveMax: 'Evolution complete',
  planned: 'planned',
  implemented: 'playable',
  protected: 'Protection {s}s — firing cancels it',
  bonusActive: 'Comeback bonus ×2: {s}s · {xp} XP left',
  heat: 'Heat',
  charge: 'Charge',
  deadTitle: 'Tank destroyed',
  deadBy: 'Destroyed by {name}',
  deadByEnv: 'Destroyed by the environment',
  deadScore: 'Life score: {n}',
  deadLevel: 'Level reached: {n}',
  deadTime: 'Time alive: {n}',
  deadKills: 'Eliminations: {n}',
  respawnFree: 'Restart as a small tank',
  respawnBonus: 'Comeback bonus: ×2 XP for {s}s (capped at 20% of lost XP).',
  respawnNoBonus: 'No comeback bonus below level 10.',
  killed: 'You eliminated {name} (+{xp} XP)',
  levelUp: 'Level {n}!',
  evolved: 'New class: {name}',
  bonusEnded: 'Comeback bonus ended',
  settingsAudio: 'Volume',
  settingsParticles: 'Particles',
  settingsLow: 'Low',
  settingsMedium: 'Medium',
  settingsHigh: 'High',
  settingsShake: 'Screen shake',
  settingsReducedMotion: 'Reduced motion',
  settingsAutofire: 'Auto-fire on start',
  settingsJoyOpacity: 'Joystick opacity',
  settingsJoySensitivity: 'Touch aim sensitivity',
  settingsDeadzone: 'Joystick dead zone',
  settingsJoyFixed: 'Fixed joystick position',
  settingsQuality: 'Internal resolution',
  on: 'On',
  off: 'Off',
  autofireOn: 'Auto-fire: on (E)',
  autofireOff: 'Auto-fire: off (E)',
  autofire: 'Auto-fire',
  stats: 'Stats',
  landscapeHint: 'Rotate your phone to landscape for a better experience.',
  helpPc: 'PC: WASD / ZQSD or arrows to move, mouse to aim, hold click to fire, E toggles auto-fire, 1–8 for stats.',
  helpMobile: 'Mobile: left stick moves, right stick aims and fires (beyond the dead zone).',
  helpBots: 'Bots always carry a BOT badge. There are never fake players.',
  helpFairView: 'Every screen gets the same field of view.',
  treeIntro: 'The catalogue’s 150 class nodes.',
  treeFamily: 'Family',
  wip: 'Development build — guest progress is not saved.',
  ping: 'Ping {n} ms',
  fps: '{n} FPS',
  rotationWarn: 'Map change in {s}s',
  rotationDone: 'New map: {map}',
  rotationIn: 'Next map in {t}',
  rotationPending: 'Rotation after the boss',
  bossSpawn: 'A boss appeared in the violet zone: {name}',
  bossDown: 'Boss defeated! Podium: {names}',
  bossRetreat: 'The boss retreats (5 min elapsed) — no reward',
  bossIn: 'Boss in {t}',
  bossAlive: '{name} · {hp}% · {t}',
  boss_bastion: 'Colossal Bastion',
  boss_faucheur: 'Colossal Reaper',
  boss_sentinelle: 'Colossal Sentinel',
  boss_chimere: 'Chimera',
  map_A: 'Archipelago',
  map_B: 'Spiral',
  map_C: 'Bipole',
  zoneLegend: 'Zones: grey = shapes · I green · II orange · III red · BOSS violet',
  slot_weapon: 'Weapon modification',
  slot_chassis: 'Chassis modification',
  slot_passive: 'Passive',
  modTeamOnly: 'Only active in team modes',
  modEquipped: 'Modification: {name}',
  locked: 'A missile has locked on to you!',
  shield: 'Shield',
  telemetry: 'Distance: {n}',
  info_rearAlert: 'Projectile behind you',
  treeMods: 'Modifications (300)',
  treeClasses: 'Classes (150)',
  modCompat: 'Compatible: {list}',
  modAny: 'all classes',
  rewardCoins: '{n} coins',
  rewardGems: '{n} gems',
  token_tok_x2: '×2 token',
  token_tok_x5: '×5 token',
  token_tok_restore: 'Restore token',
  token_tok_reset: 'Reset token',
  token_tok_salon: 'Lobby token',
  account: 'Account',
  loading: 'Loading…',
  tab_profile: 'Profile',
  tab_pass: 'Pass',
  tab_friends: 'Friends',
  forgotSent: 'If an account exists for this address, an email has been sent.',
  registered: 'Account created. Verify your email to cash out the roulette and to purchase.',
  rateLimited: 'Too many attempts, try again in a minute.',
  badCredentials: 'Wrong email or password.',
  err_email: 'Invalid email address.',
  err_password: 'Password: at least 10 characters.',
  err_name: 'Invalid display name (3 to 16 characters, no reserved name).',
  err_server: 'Server error, please retry.',
  guestInfo: 'You are playing as a guest ({n} provisional coins). Create an account or log in to keep them: they are transferred once.',
  email: 'Email',
  password: 'Password',
  displayName: 'Display name',
  login: 'Log in',
  register: 'Create account',
  sendReset: 'Send link',
  forgot: 'Forgot password',
  oauthSoon: 'Google and Discord sign-in: available once the game’s public address is configured.',
  verified: 'email verified',
  notVerified: 'email not verified',
  sent: 'Sent',
  resend: 'Resend',
  dailyMissions: 'Daily missions (+{c} coins, +{x} pass XP each)',
  weeklyMissions: 'Weekly missions (+{c} coins, +{x} pass XP each)',
  rouletteWeek: 'Roulette this week: {n} / {max} (resets Monday 00:00 UTC).',
  logout: 'Log out',
  passEnds: 'ends {d}',
  buyPremium: 'Premium pass — 900 gems',
  premiumInfo: 'One-time purchase for the season, no renewal. Premium rewards already reached are granted once.',
  premium_ok: 'Premium pass activated.',
  premium_already: 'You already own the premium pass.',
  premium_funds: 'Not enough gems.',
  premium_verify: 'Verify your email before any purchase.',
  premium_server: 'Server error.',
  addFriend: 'Add',
  noFriends: 'No friends yet. Share your public ID (TS-…).',
  online: 'online',
  offline: 'offline',
  fstatus_friend: 'friend',
  fstatus_outgoing: 'request sent',
  fstatus_incoming: 'request received',
  accept: 'Accept',
  remove: 'Remove',
  block: 'Block',
  friend_sent: 'Request sent.',
  friend_accepted: 'You are now friends.',
  friend_blocked: 'Not possible: a block is active.',
  friend_self: 'That is your own ID.',
  friend_exists: 'Already friends or request pending.',
  friend_unknown: 'ID not found.',
  devMailbox: 'Test mailbox (development)',
  devMailboxOff: 'Unavailable (production).',
  roulette: 'End-of-run roulette',
  rouletteShort: 'Roulette',
  rLevel: 'Level {n}',
  rActive: 'Active time: {a} / {b}',
  rRaw: 'Raw XP: {a} / {b}',
  rFeats: '3 eliminations ({k}) or 30 monsters ({m})',
  rWeek: 'Cash-outs this week: {n} / 3',
  rNeedAccount: 'An account is required to cash out.',
  rNeedVerify: 'A verified email is required to cash out.',
  rConfirm: 'Cashing out ends your tank and this run. Restores will no longer be possible. The result is drawn by the server.',
  rCashout: 'Cash out',
  cancel: 'Cancel',
  rResCoins: '{n} coins',
  rResPass: '+{n} pass levels (converted: {c} coins)',
  rResSingularity: 'Exceptional “Singularity” cosmetic ({v})!',
  rOdds: 'Odds: 5000 coins 50% · 5 tokens 35% · 5 pass levels 14.999% · Singularity 0.001%.',
  cashoutErr_unavailable: 'Cash-out unavailable.',
  cashoutErr_account: 'An account is required to cash out.',
  cashoutErr_verify: 'Verify your email to cash out.',
  cashoutErr_eligibility: 'Roulette requirements not met.',
  cashoutErr_combat: 'Stay out of combat for 10 seconds before cashing out.',
  cashoutErr_zone: 'Not possible in the boss zone.',
  cashoutErr_cap: 'Weekly limit of 3 cash-outs reached.',
  cashoutErr_error: 'Server error: nothing was drawn or charged.',
  cashedTitle: 'Run cashed out',
  guestChip: 'Guest — log in',
  verifyOk: 'Email address verified.',
  verifyFail: 'Invalid or expired verification link.',
  resetOk: 'Password changed: please log in again.',
  resetFail: 'Invalid or expired reset link.',
  resetTitle: 'New password',
  boostActive: 'Boost {k}: {s}s',
  boostEnded: 'Boost ended',
  chfInfo: 'Final prices in CHF. Gems cannot be withdrawn, traded or resold.',
  confirm: 'Confirm',
  convert: 'Convert',
  convertTitle: 'Gems → coins conversion (one way)',
  equip: 'Equip',
  gemPacks: 'Gems',
  inventoryTitle: 'My looks',
  orderCancelled: 'Payment cancelled: nothing was charged.',
  orderChecking: 'Checking the payment with the server…',
  orderFailed: 'Payment failed: no gems credited.',
  orderPaid: 'Payment confirmed: {n} gems credited.',
  orderPending: 'Payment still awaiting confirmation. Gems arrive as soon as it is confirmed.',
  owned: 'Owned',
  paySimulator: 'DEVELOPMENT MODE — fake payment simulator: no real money, no card.',
  payStripeTest: 'Stripe test mode: use Stripe test cards, no real money.',
  payStripeLive: 'Real payments enabled.',
  resetBtn: 'Reset ({n})',
  resetConfirm: 'Keep XP, refund points and modifications, go back to the base class? Out of combat 8s, once per life, 15 min apart.',
  restoreBtn: 'Restore my progress (tokens: {n}, restores: {r})',
  shopVerify: 'Verify your email to purchase.',
  tokensInfo: 'Tokens give an advantage in the modes that allow them (FFA); they are not purely cosmetic.',
  tokensTitle: 'Tokens',
  weeklyShop: 'Weekly shop (next rotation: {d})',
  shop_ok: 'Purchase complete.',
  shop_owned: 'Already owned.',
  shop_funds: 'Insufficient balance.',
  shop_unavailable: 'Offer not available this week.',
  shop_frozen: 'Spending frozen: a refund is under review.',
  shop_verify: 'Verify your email to purchase.',
  shop_invalid: 'Invalid request.',
  shop_closed: 'Gem purchases are not open yet.',
  ckind_skin: 'Look',
  ckind_collection: 'Multi-class collection',
  ckind_emblem: 'Emblem',
  ckind_trail: 'Trail',
  ckind_killfx: 'Elimination effect',
  ckind_deathfx: 'Destruction effect',
  ckind_banner: 'Banner',
  ckind_frame: 'Frame',
  base_atelier: 'Workshop (steel)',
  base_desert: 'Desert (sand)',
  base_boreal: 'Boreal (blue)',
  base_obsidienne: 'Obsidian (black)',
  base_signal: 'Signal (orange)',
  tokenOk_tok_x2: '×2 boost activated (90s)',
  tokenOk_tok_x5: '×5 boost activated (60s, tank eliminations)',
  tokenOk_tok_restore: 'Progress restored',
  tokenOk_tok_reset: 'Build reset: pick a new branch',
  tokenErr_unavailable: 'Token unavailable here.',
  tokenErr_active: 'A boost is already active ({s}s left): token not used.',
  tokenErr_bonus: 'The comeback bonus is active ({s}s): token not used.',
  tokenErr_limit: 'Limit reached: token not used.',
  tokenErr_expired: 'Restore window has passed.',
  tokenErr_combat: 'Stay out of combat for 8 seconds first.',
  tokenErr_zone: 'Not possible in the boss zone.',
  tokenErr_none: 'You do not have this token.',
  tokenErr_cooldown: 'Reset on cooldown (15 min per account).',
  tokenErr_error: 'Server error: token not used.',
  tokenErr_state: 'The situation changed: token refunded.',
  tab_shop: 'Shop',
  botsInMatch: '{n} announced bot(s) in this match',
  closeLobby: 'Close lobby',
  defeat: 'Defeat',
  draw: 'Draw',
  kick: 'Kick',
  lobbyCode: 'Lobby',
  lobbyExpires: 'Lobby ends: {d}',
  lock: 'Lock',
  unlock: 'Unlock',
  makeHost: 'Make host',
  map_T: 'Neutral ground',
  noRewards: 'Custom game — no rewards',
  overtime: 'Overtime {t}',
  prepIn: 'Preparation: {s}s',
  privBoss: 'Boss',
  privBots: 'Bots',
  privCode: 'Lobby code (6 characters)',
  privCreate: 'Create lobby',
  privInfo: 'Active premium pass or a lobby token (only used when the lobby opens), 4 h, one active lobby per account. No rewards.',
  privJoin: 'Join',
  privMap: 'Map',
  privMax: 'Max players',
  privMonsters: 'Monsters',
  privTeams: 'Teams',
  privAdvanced: 'Advanced options',
  privDmg: 'Tank damage (×)',
  privHp: 'Tank health (×)',
  privMaxLevel: 'Max level',
  privProtection: 'Spawn protection',
  privRotation: 'Map rotation',
  privShapes: 'Shapes',
  privStartLevel: 'Starting level',
  privTeamsMap: 'Teams: neutral ground, no rotation, monsters or boss.',
  privXp: 'XP multiplier',
  quickTitle: 'Quick messages (F1–F6)',
  teamRewardInfo: 'Rewards: 100 coins for full participation + 50 for a win, prorated by time played.',
  victory: 'Victory!',
  waitingPlayers: 'Waiting for players — announced bots in {s}s',
  waveOf: 'Wave {n} / {max}',
  teamRespawn: 'Respawn with 75% of your XP: level, class and points recalculated (points to reassign).',
  survivalSpectate: 'Spectating until the next cleared wave, then back with 75% of your XP.',
  mode_ffa: 'Free arena',
  mode_tdm: 'Team deathmatch',
  mode_dom: 'Domination',
  mode_survival: 'Survival',
  mode_private: 'Private game',
  modeDesc_ffa: 'Everyone for themselves, labelled bots fill in, rotating maps, bosses.',
  modeDesc_tdm: 'Two teams, 10 minutes or 30/60/100 eliminations. You keep 75% of your XP on death.',
  modeDesc_dom: 'Three points to capture (8s uncontested), 1 point per second held, 1000 or 12 minutes.',
  modeDesc_survival: 'Co-op for 1 to 6 players, 30 waves, a boss every 5 waves.',
  modeDesc_private: 'Custom rules, no rewards at all.',
  diff_facile: 'Easy',
  diff_normal: 'Normal',
  diff_moyen: 'Medium',
  diff_difficile: 'Hard',
  diff_ultra: 'Ultra hard',
  diff_tankshift: 'TANKSHIFT',
  quick_gg: 'Well played',
  quick_warning: 'Watch out',
  quick_joinMe: 'Join me',
  quick_thanks: 'Thanks',
  quick_help: 'Help',
  quick_retreat: 'Fall back',
  leave_ended: 'The match is over.',
  leave_kicked: 'You were kicked from the lobby.',
  leave_lobby_auth: 'Log in to create a lobby.',
  leave_lobby_one: 'You already have an active lobby.',
  leave_lobby_token: 'You need an active premium pass or a lobby token.',
  leave_lobby_error: 'Error while opening the lobby: no token used.',
  leave_lobby_missing: 'Lobby not found, locked or full.',
  matchStartsIn: 'Round starts in {s}s',
  group: 'Party',
  groupLeave: 'Leave',
  decline: 'Decline',
  groupInvitedBy: '{name} invited you to their party ({n})',
  groupPromote: 'Make leader',
  groupPending: 'invite sent',
  groupEmpty: 'Invite friends to play together: same match and same team (4 max in the free arena where you stay opponents, 6 in survival, one team’s size in matches).',
  groupPlaceholder: 'Message your party',
  groupSend: 'Send',
  groupReport: 'Report or block',
  groupJoinLaunch: 'Join your party',
  groupTooBig: 'Your party has {n} players: this mode allows at most {max}.',
  groupLeaderPlays: 'The party leader starts the game for the whole party.',
  blockedDone: '{name} is blocked: their messages are hidden.',
  queuePlayers: '{n} playing',
  ginv_sent: 'Invite sent.',
  ginv_self: 'You cannot invite yourself.',
  ginv_not_friend: 'Only your friends can be invited.',
  ginv_blocked: 'Invite not possible (blocked).',
  ginv_full: 'Party full (8 at most).',
  ginv_already: 'Already in the party.',
  ginv_not_leader: 'Only the leader can invite.',
  ginv_unknown: 'Player not found.',
  gacc_ok: 'You joined the party.',
  gacc_expired: 'Invite expired.',
  gacc_full: 'Party full.',
  gacc_blocked: 'Not possible: a party member is blocked.',
  chat_rate: 'Too many messages: wait a moment.',
  chat_dup: 'Same message already sent.',
  chat_empty: 'Empty message.',
  chat_no_group: 'You are no longer in a party.',
  chat_error: 'Could not send.',
  report_ok: 'Report sent, thank you.',
  report_dup: 'Already reported.',
  report_rate: 'Too many reports: try again later.',
  report_reason: 'Invalid reason.',
  report_self: 'You cannot report yourself.',
  report_unknown: 'Player not found.',
  report_error: 'Could not report.',
  gsys_joined: '{name} joined the party.',
  gsys_left: '{name} left the party.',
  gsys_kicked: '{name} was removed from the party.',
  gsys_leader: '{name} is the new leader.',
  gsys_launch: '{name} started a game.',
  reason_insult: 'Insult',
  reason_spam: 'Spam',
  reason_cheat: 'Cheating',
  reason_other: 'Other',
  leave_group_size: 'Party too large for this mode.',
  play: 'Play',
  wipAccount: 'Development build — progress is saved to your account.',
  variantsTitle: 'Base variants',
  variantsIntro: 'Each class has 5 free variants (Workshop, Desert, Boreal, Obsidian, Signal), unlocked by playing that class.',
  variantsInTree: 'The 5 styles unlock class by class in the class tree.',
  noCosmetic: 'Remove cosmetic (per-class variants)',
  variantsShow: 'Show variants',
  variantsLogin: 'Log in to unlock and choose variants.',
  variantChosen: '{style} variant chosen for this class.',
  variantLockedMsg: 'Variant still locked.',
  variantNeedTime: '{have}/{need} min',
  variantNeedKills: '{have}/{need} eliminations',
  variantMastery: 'mastery: {min} min, {kills} eliminations',
  settingsSfx: 'Combat effects',
  settingsUiSounds: 'Interface sounds',
  settingsMuteHidden: 'Mute in background',
  settingsA11y: 'Accessibility',
  settingsColors: 'Colours',
  colorsStandard: 'Standard',
  colorsRedGreen: 'Red-green colour blindness',
  colorsBlueYellow: 'Blue-yellow colour blindness',
  settingsTextSize: 'Text size',
  settingsContrast: 'High contrast',
  settingsVisualCues: 'Visual sound cues',
  premium_ended: 'The season is over: next season’s premium pass will be offered when it opens.',
  passEnded: 'Season over — pass frozen until the next season.',
  translationReview: 'Reviewed translation.',
  // Interface redesign (November 2026).
  navMain: 'Main navigation',
  nav_hangar: 'Hangar',
  nav_tree: 'Tree',
  nav_pass: 'Pass',
  nav_shop: 'Shop',
  nav_friends: 'Friends',
  walletLabel: '{c} coins, {g} gems',
  hangarModes: 'Mission orders',
  hangarYourTank: 'Your tank',
  hangarSkin: 'Look: {name}',
  hangarNoSkin: 'Per-class variants',
  hangarEvo: 'First evolution at level {n}: {k} families',
  hangarControls: 'Controls',
  hangarCallsign: 'Tank name',
  hangarStageLabel: 'Animated preview: {name}. Click or tap to fire.',
  hangarFireHint: 'Click to fire',
  hangarTapHint: 'Tap to fire',
  modeFormat: 'Format',
  modeDifficulty: 'Difficulty',
  seasonTag: 'Season {n}',
  seasonGuest: '105-level pass: create an account to progress and keep your rewards.',
  seasonNext: 'Level {n}',
  seasonMissions: 'daily missions: {n}/{max}',
  groupLeader: 'Leader',
  groupInviteFriends: 'Invite a friend',
  passTitle: 'Battle pass',
  passYourLevel: 'Your level',
  passPreview: 'Pass preview',
  passLevelOf: 'Level {n} of {max}',
  passLevels: 'Levels: {n}',
  passXpInfo: '100 pass XP per active minute, plus missions. 2,000 XP per level.',
  passGuestInfo: 'You can browse every reward. Create an account to earn pass XP.',
  passPremium: 'Premium',
  passFree: 'Free',
  passPremiumActive: 'Premium pass active',
  passPremiumActiveInfo: 'The premium reward of every level you reach is granted automatically.',
  passBalance: 'Your balance:',
  passTrackLabel: 'Rewards for all 105 levels',
  passPrev: 'Previous levels',
  passNext: 'Next levels',
  passHere: 'You',
  passClaimed: 'claimed',
  passReached: 'reached',
  passPremiumNeeded: 'premium pass required',
  passIn: 'levels to go: {n}',
  passNewTitle: 'New tier',
  passNewOne: 'Level {n} reached since your last visit.',
  passNewMany: 'Levels {a} to {b} reached since your last visit.',
  passEarnTitle: 'Earn pass XP',
  missionDone: 'Done',
  tokenShort_tok_x2: '×2',
  tokenShort_tok_x5: '×5',
  tokenShort_tok_restore: 'Restore',
  tokenShort_tok_reset: 'Reset',
  tokenShort_tok_salon: 'Lobby',
  tokdesc_tok_x2: '×2 on all tank XP for 90 s, in the free arena.',
  tokdesc_tok_x5: '×5 on tank-kill XP for 60 s, in the free arena.',
  tokdesc_tok_restore: 'After a death, get your exact tank back: level, class, points and mods.',
  tokdesc_tok_reset: 'Back to the base class with your XP kept, to pick another branch.',
  tokdesc_tok_salon: 'Opens a private lobby for 4 h, with no rewards.',
  rkind_coins: 'Coins',
  rkind_gems: 'Gems',
  rkind_token: 'Token',
  rkind_emblem: 'Emblem',
  rkind_banner: 'Banner',
  rkind_killfx: 'Elimination effect',
  rkind_deathfx: 'Destruction effect',
  rkind_shotfx: 'Shot effect',
  rkind_trail: 'Trail',
  rkind_frame: 'Frame',
  rkind_collection: 'Collection',
  rkind_item: 'Item',
  rkdesc_coins: 'Coins to spend in the weekly shop.',
  rkdesc_gems: 'Gems: premium looks, tokens and the premium pass.',
  rkdesc_item: 'Collectible from season {s}, kept in your inventory after the season ends.',
  shopSub: 'Fixed prices, contents shown before you buy.',
  shopSections: 'Shop sections',
  shopSec_week: 'This week',
  shopSec_gems: 'Gems',
  shopSec_tokens: 'Tokens',
  shopSec_convert: 'Conversion',
  shopSec_owned: 'My looks',
  shopSec_history: 'History',
  shopWeekNext: 'New selection on {d}',
  shopGuest: 'You can look at everything. Create an account to buy and keep items.',
  shopPreview: 'Preview',
  shopPreviewOf: 'Preview of {name}',
  shopPreviewClasses: 'See it on another class',
  shopConfirm: 'Confirm',
  shopBoughtStamp: 'Bought',
  shopEquipped: 'Look equipped.',
  shopEquippedBadge: 'Equipped',
  shopOwnedCount: 'In stock: {n}',
  shopPaletteInfo: 'The palette applies to all your classes while it is equipped.',
  shopItemInfo: 'Collectible with no effect on gameplay.',
  shopFairInfo: 'A cosmetic never changes the hitbox, accuracy or how readable shots are.',
  convertInfo: 'One-way conversion: coins never turn back into gems.',
  historyEmpty: 'No purchases yet.',
  hist_shop: 'Shop purchase',
  hist_tokens: 'Token purchase',
  hist_convert: 'Conversion',
  hist_gemspack: 'Gem pack',
  hist_premiumpass: 'Premium pass',
  hist_refund: 'Refund',
  hist_tokenuse: 'Token used',
  hist_tokenrefund: 'Token returned',
  rOddsTitle: 'Odds and rules',
  rOddsTokens: 'The 5 tokens are drawn one by one: ×2 40%, ×5 20%, restore 20%, reset 15%, lobby 5%.',
  rRules: 'Singularity already owned: another variant you don’t own, otherwise 5000 coins. Pass already at level 105 or between seasons: each level won becomes 500 coins.',
  shopPackReduced: 'Reduced price: you already own part of the contents.',
  singularityName: 'Singularity',
  collectionTitle: 'My collection',
  mailUnavailable: 'Email isn’t available yet: address verification and password reset are coming soon.',
  registeredNoMail: 'Account created. Email address verification isn’t available yet: you can do it later.',
  authSub: 'Play as a guest or create an account to keep your progress.',
  authPerksTitle: 'With an account',
  authPerkPass: 'Your season pass progresses and its rewards are kept.',
  authPerkVariants: 'The 5 styles of each class unlock as you play.',
  authPerkFriends: 'Friends, party and party chat.',
  authPerkShop: 'Shop, missions and the end-of-run roulette.',
  authRegisterHint: 'Password: at least 10 characters. Display name: 3 to 16 characters.',
  profileSub: 'Your identity, balance and tokens.',
  profileWallet: 'Balance',
  profileVerifyWhy: 'Verify your email to buy items and cash out the roulette.',
  renameBtn: 'Rename',
  renameOk: 'Display name changed.',
  renameFail: 'Name refused: 3 to 16 characters, no reserved names.',
  copy: 'Copy',
  copied: 'Copied',
  copyId: 'Copy ID',
  friendsSub: 'Add friends with their public ID and play as a party.',
  friendsGuest: 'Friends and parties need an account.',
  friendsYourId: 'Your ID',
  friendsAddLabel: 'A friend’s public ID',
  settingsSub: 'Settings kept on this device.',
  settingsSoundTitle: 'Sound',
  settingsDisplayTitle: 'Display',
  settingsControlsTitle: 'Controls',
  settingsVisualCuesHint: 'Screen edge flashes red when you are hit.',
  settingsReducedMotionHint: 'Turns off menu, background and roulette animations.',
  settingsQualityHint: 'Lower: smoother on small devices.',
  colorSelf: 'You',
  colorAlly: 'Ally',
  colorEnemy: 'Opponent',
  helpSub: 'Controls, map zones and match rules.',
  helpPcTitle: 'Keyboard and mouse',
  helpTouchTitle: 'Touch screen',
  helpZonesTitle: 'Map zones',
  helpFairTitle: 'Fair play',
  helpMove: 'Move',
  helpAimFire: 'Aim, fire',
  helpSticks: 'Left: move · Right: aim and fire',
  treePlayable: 'Playable classes: {n}.',
  treeSearch: 'Search a class',
  treeAll: 'All',
  treeNoResult: 'No results.',
  modsSearch: 'Search a mod',
  modsSlot: 'Slot',
  variantInUse: 'Style used in matches',
  variantUse: 'Use the {style} style',
  deadLevelShort: 'Level',
  deadTimeShort: 'Time',
  deadKillsShort: 'Kills',
  legalNav: 'Legal information',
  legal_legal: 'Legal notice',
  legal_privacy: 'Privacy',
  legal_terms: 'Terms of sale',
  legalUpdated: 'Version of {d}',
  legalToc: 'Contents',
  legalDraft: 'Draft: the details marked TODO are still to be filled in by the publisher.',
  legalTranslated: 'Translation provided for information: in case of any difference, the French version prevails.',
  legalShowFr: 'Read in French',
  legalShowMine: 'Back to my language',
  legalHelp: 'Who publishes the game, what happens to your data and the rules for purchases.',
  legalContact: 'Contact: {email}',
  authLegal: 'By creating an account, you confirm you are at least 13 years old. What happens to your data: {privacy}. Purchase rules: {terms}.',
  profileDataTitle: 'Your data',
  profileData: 'To get a copy of your data, correct it or delete your account, write to {email} from your account’s email address.',
};
